import Marquee from "react-fast-marquee";
import { TECH_MARQUEE } from "@/data/content";

const TechMarquee = () => {
  return (
    <div
      className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden"
      data-testid="tech-marquee"
    >
      <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
      <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />
      <Marquee speed={28} gradient={false} pauseOnHover>
        {TECH_MARQUEE.map((tech, i) => (
          <span
            key={i}
            className="flex items-center gap-8 mx-8 font-outfit text-xl sm:text-2xl font-medium text-white/25 hover:text-[#00D2D3]/70 transition-colors duration-300"
          >
            {tech}
            <span className="text-[#00D2D3]/40 text-sm">&#9670;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default TechMarquee;
